import SessionCreate from './create';
import SessionHeader from './header';
import SessionList from './list';
import SessionInspect from './inspect';
import SessionOverview from './overview';
import { watchSession, watchSessionAttrs } from 'data/session';

const initSub = ({ sessionKey }) => {
  watchSessionAttrs();
  watchSession(sessionKey);
};
export default {
  path: '/',
  label: 'Sessions',
  hideToolbar: true,
  component: SessionList,

  routes: [
    {
      label: 'Overview',
      path: 'session/:sessionKey',
      component: SessionInspect,
      init: initSub,
      hideToolbar: true,
      titleComponent: SessionHeader
    },

    {
      label: 'Data',
      path: 'session/:sessionKey/data',
      component: SessionInspect,
      hideToolbar: true,
      init: initSub,
      titleComponent: SessionHeader
    },
    {
      label: 'Session create',
      path: 'session/create',
      component: SessionCreate,
      hidden: true
    }
  ]
};
